var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10.0937V8.23437C16.25 7.60034 15.9537 6.99228 15.4262 6.54395C14.8988 6.09562 14.1834 5.84375 13.4375 5.84375H12.1875C11.9389 5.84375 11.7004 5.75979 11.5246 5.61035C11.3488 5.46091 11.25 5.25822 11.25 5.04687V3.98437C11.25 3.35034 10.9537 2.74228 10.4262 2.29395C9.89879 1.84562 9.18342 1.59375 8.4375 1.59375H6.875M8.125 7.96875L10 10.0937M10 10.0937L11.875 7.96875M10 10.0937V13.2812M8.125 10.625H11.875M8.125 12.2187H11.875M8.75 1.59375H4.6875C4.17 1.59375 3.75 1.95075 3.75 2.39062V14.6094C3.75 15.0492 4.17 15.4062 4.6875 15.4062H15.3125C15.83 15.4062 16.25 15.0492 16.25 14.6094V7.96875C16.25 6.27799 15.4598 4.65649 14.0533 3.46094C12.6468 2.2654 10.7391 1.59375 8.75 1.59375Z",
    stroke: "#595959",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.067973b17ec4b67db631a4f5da983b0f.svg";
export { ForwardRef as ReactComponent };